import React from "react";
import { TailSpin } from "react-loader-spinner";
import "./ListPanel.css";

type Props = {
  /** When true, show a centered loader instead of the content. */
  loading?: boolean;
  children: React.ReactNode;
};

// Shared content wrapper for the catalog/list pages: a centered loader while
// data is in flight, otherwise the content (an AntD Table or an error alert)
// inside a rounded surface panel so every list reads as one cohesive card.
export default function ListPanel({ loading, children }: Props) {
  if (loading) {
    return (
      <div className="list-panel-loading">
        <TailSpin height={72} width={72} color="#9c1419" radius="1" />
      </div>
    );
  }
  return <div className="list-panel">{children}</div>;
}
